
const digest = 'ad4d8bdb11fd21e7d199c24cf1485638897a34a6f0a654e07c9154bfa2d2d2ea';
const classes = {"wrapper":"_wrapper_cmy63_1","quickAdjustmentWrapper":"_quickAdjustmentWrapper_cmy63_8"};
const css = `._wrapper_cmy63_1 {
  flex: 1 1;
  padding: 0 8px;
  min-height: 96px;
  text-align: center;
}

._quickAdjustmentWrapper_cmy63_8 {
  flex-basis: 32%;
  flex-grow: 1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  